import Denominations from '../../../../../models/data/Denomination';
import * as React from 'react';
import PopupButtons from './PopupButtons';
import { TextField } from '@symphony-ui/uitoolkit-components';
import { bigRegex, convertBigNumber } from '../regexes';
const DenominationsPopup = ({ data, hasOverride, save }) => {
    const currency = React.useMemo(() => data?.currency(), [data]);
    const [minimum, setMinimum] = React.useState(data?.override?.documentation?.denominations?.minimum?.value?.toString() ?? data?.data?.documentation?.denominations?.minimum?.value?.toString() ?? '');
    const [multiple, setMultiple] = React.useState(data?.override?.documentation?.denominations?.multiple?.value?.toString() ?? data?.data?.documentation?.denominations?.multiple?.value?.toString() ?? '');
    const onChangeMinimum = React.useCallback((event) => {
        const newValue = event.target.value.toUpperCase();
        if (bigRegex.exec(newValue)) {
            setMinimum(newValue);
        }
    }, []);
    const onChangeMultiple = React.useCallback((event) => {
        const newValue = event.target.value.toUpperCase();
        if (bigRegex.exec(newValue)) {
            setMultiple(newValue);
        }
    }, []);
    const denominations = React.useMemo(() => {
        const minValue = minimum !== "" ? convertBigNumber(minimum) : undefined;
        const multValue = multiple !== "" ? convertBigNumber(multiple) : undefined;
        return new Denominations({
            minimum: {
                currency,
                value: minValue
            },
            multiple: {
                currency,
                value: multValue
            }
        });
    }, [currency, minimum, multiple]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: 'flex' } },
            React.createElement("span", { style: { alignSelf: 'end', marginBottom: '0.5rem', marginRight: '0.5rem' } }, currency),
            React.createElement("div", { style: { marginRight: '0.25rem', width: '5rem' } },
                React.createElement(TextField, { label: "Minimum", onChange: onChangeMinimum, value: minimum })),
            React.createElement("div", { style: { width: '5rem' } },
                React.createElement(TextField, { label: "Multiple", onChange: onChangeMultiple, value: multiple }))),
        React.createElement("div", { style: { display: 'flex', justifyContent: 'right', marginTop: '0.5rem' } },
            React.createElement(PopupButtons, { isDisabled: false, value: denominations, hasOverride: hasOverride, save: save }))));
};
export default DenominationsPopup;
